'use client';

import * as DS from '@aurorasolar/ds';

import { useCurrency } from '@/hooks/useCurrency';

import { METHODOLOGY_INTRO, METHODOLOGY_NOTES } from '../content';
import { SimulationResult } from '../engine';

type Props = {
  result?: SimulationResult;
  stateCode?: string;
};

export const MethodologySection = ({ result, stateCode }: Props) => {
  const { formatCurrency } = useCurrency();

  return (
    <DS.Flex gap={3} maxW="640px" mx="auto" w="100%">
      <DS.Text as="h2" text="h1">
        How this simulation works
      </DS.Text>
      <DS.Text color="uiHelperCopy" text="body14">
        {METHODOLOGY_INTRO}
      </DS.Text>
      {result && stateCode ? (
        <DS.Text color="uiHelperCopy" text="body14">
          <span>For this simulation we used </span>
          <DS.Text as="b" text="body14">
            {formatCurrency(result.assumptions.ratePerKwhUsd, 2)}/kWh
          </DS.Text>
          <span>
            , the average residential electricity rate in {stateCode}, and about{' '}
            {Math.round(result.assumptions.annualKwh).toLocaleString()} kWh of annual usage implied by your bill.
          </span>
        </DS.Text>
      ) : null}
      <DS.Flex as="ul" gap={2} m={0} pl={5}>
        {METHODOLOGY_NOTES.map((note) => (
          <DS.Text as="li" color="uiHelperCopy" key={note} text="body14">
            {note}
          </DS.Text>
        ))}
      </DS.Flex>
    </DS.Flex>
  );
};
